import { render, staticRenderFns } from "./weightTask.vue?vue&type=template&id=7919a897&scoped=true"
import script from "./weightTask.vue?vue&type=script&lang=js"
export * from "./weightTask.vue?vue&type=script&lang=js"
import style0 from "./weightTask.vue?vue&type=style&index=0&id=7919a897&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7919a897",
  null
  
)

export default component.exports